module.exports = function getNavItem(entity, sitemap = null) {
	let nav_item;
	if (sitemap && Array.isArray(sitemap) ) {
		nav_item = sitemap.find((item) => item.id === entity.id);
	} else if(sitemap && sitemap[entity.id]) {
    nav_item = sitemap[entity.id];
  }
	return nav_item;
};
